import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ProductUnitService {
  is_display_product_unit_register_component = false;
  productUnitUpdate = new EventEmitter<ProductUnit>();

  downloadProductUnit = new EventEmitter<boolean>();
  private _product_unit_data: ProductUnit = null;

  constructor() { }
  set set_product_unit_data(product_unit) {
    this._product_unit_data = product_unit;
  }

  get get_product_unit_data() {
    return this._product_unit_data;
  }
}

export interface ProductUnit {
  id: number;
  name: string;
}
